import React from 'react';
import { BlogSidebar } from '../blog-classic/BlogParts';

function Blog({ blog, allBlogs }) {
  if (!blog) {
    return (
      <section className="blog section-padding">
        <div className="container text-center">
          <h4>Blog yazısı bulunamadı.</h4>
          <a href="/blog-classic" className="main-color mt-30 d-inline-block">
            Bloga Dön
          </a>
        </div>
      </section>
    );
  }

  const paragraphs = (blog.content || blog.excerpt || '').split('\n').filter(Boolean);

  return (
    <section className="blog section-padding">
      <div className="container">
        <div className="row xlg-marg">
          <div className="col-lg-8">
            <div className="main-post">
              <div className="item pb-60">
                <article>
                  {paragraphs.map((para, i) => (
                    <div key={i} className={`text ${i > 0 ? 'mt-20' : ''}`}>
                      {i === 0 ? (
                        <p>
                          <span className="spec-letter">{para.charAt(0)}</span>
                          {para.slice(1)}
                        </p>
                      ) : (
                        <p>{para}</p>
                      )}
                    </div>
                  ))}
                </article>
              </div>
              <div className="info-area flex pt-50 bord-thin-top">
                <div>
                  <div className="tags flex">
                    <div className="valign">
                      <span>Etiketler :</span>
                    </div>
                    <div>
                      {(blog.tags || [blog.category]).map((tag) => (
                        <a key={tag} href="/blog-classic">{tag}</a>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="ml-auto">
                  <div className="share-icon flex">
                    <div className="valign">
                      <span>Paylaş :</span>
                    </div>
                    <div>
                      <a href="https://www.facebook.com/">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a href="https://www.twitter.com/">
                        <i className="fab fa-twitter"></i>
                      </a>
                      <a href="https://www.youtube.com/">
                        <i className="fab fa-youtube"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="author-area mt-50 bord-thin-bottom">
                <div className="flex">
                  <div className="author-img mr-30">
                    <div className="img">
                      <img
                        src="/assets/imgs/blog/author.png"
                        alt=""
                        className="circle-img"
                      />
                    </div>
                  </div>
                  <div className="cont valign">
                    <div className="full-width">
                      <h6 className="fw-600 mb-10">{blog.author || 'Admin'}</h6>
                      <p>Kanus Digital ekibi tarafından hazırlanan içerikler.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <BlogSidebar blogs={allBlogs} currentId={blog.id} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Blog;
